import { ClimbPerformance } from './Grade';
import { ClimbingRoute } from './ClimbingRoute';

// Climb model representing a single climbing attempt
export class Climb {
  id: string;
  date: number; // Timestamp
  climbingRoute: ClimbingRoute;
  hangs?: number;
  reachedTop: boolean;
  attempt: number;
  performance?: ClimbPerformance;

  constructor(
    id: string,
    date: number,
    climbingRoute: ClimbingRoute,
    reachedTop: boolean,
    attempt: number,
    hangs?: number,
    performance?: ClimbPerformance
  ) {
    this.id = id;
    this.date = date;
    this.climbingRoute = climbingRoute;
    this.hangs = hangs;
    this.reachedTop = reachedTop;
    this.attempt = attempt;
    this.performance = performance;
  }

  // Method to convert to Firestore data
  toFirestore() {
    return {
      id: this.id,
      date: this.date,
      climbingRoute: this.climbingRoute.toFirestore(),
      hangs: this.hangs || 0,
      reachedTop: this.reachedTop,
      attempt: this.attempt,
      performance: this.performance
    };
  }

  // Static method to create Climb from Firestore data
  static fromFirestore(data: any): Climb {
    return new Climb(
      data.id,
      data.date,
      data.climbingRoute?.id 
        ? ClimbingRoute.fromFirestore(data.climbingRoute)
        : new ClimbingRoute(data.id || ''),
      data.reachedTop,
      data.attempt,
      data.hangs,
      data.performance
    );
  }
}

// Helper functions
export const isSuccessfulClimb = (climb: Climb): boolean => {
  return climb.reachedTop;
};

export const getPerformanceLabel = (performance?: ClimbPerformance): string => {
  switch (performance) {
    case ClimbPerformance.NOT_TOPPED:
      return 'Not Topped';
    case ClimbPerformance.TOPPED:
      return 'Topped';
    case ClimbPerformance.REDPOINT:
      return 'Redpoint';
    case ClimbPerformance.ON_SIGHT:
      return 'On Sight';
    case ClimbPerformance.FLASH:
      return 'Flash';
    case ClimbPerformance.BLOCKS:
      return 'Blocks';
    default:
      return 'Unknown';
  }
};
